(() => {
  let gesture;
  let suppressClickUntil = 0;
  const cardSelector = '.card-wrapper, .ag26-card';

  document.addEventListener('pointerdown', (event) => {
    suppressClickUntil = 0;
    if (event.button !== 0 || !event.target.closest?.(cardSelector)) return;
    gesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
  }, { capture: true, passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) gesture.moved = true;
  }, { capture: true, passive: true });

  document.addEventListener('pointerup', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    if (gesture.moved) suppressClickUntil = Date.now() + 500;
    gesture = null;
  }, { capture: true, passive: true });

  document.addEventListener('pointercancel', () => { gesture = null; }, { capture: true, passive: true });

  document.addEventListener('click', (event) => {
    if (event.detail === 0 || Date.now() > suppressClickUntil) return;
    if (!event.target.closest?.(cardSelector)) return;
    suppressClickUntil = 0;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest?.(cardSelector)) event.preventDefault();
  }, true);
})();
